import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
  ListGroupItem,
  CustomInput,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// MontoringWordItem
const MontoringWordItem = (props) => {

let [importanceRanck, setImportanceRank] = useState(2)

// componentDidMount
useEffect(() => {

  // console.log("props.item.importance: ", props.item.importance, props.item.kana, props.item)

  if (props.item.importance) {
    if (props.item.importance > 1.0 ){
      setImportanceRank(1)
    } else if ( props.item.importance === 1.0) {
      setImportanceRank(2)
    } else if ( props.item.importance < 1.0) {
      setImportanceRank(3)
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [props.item]);


  // delete vocab
  let _deleteVocab = () => {
    props.deleteVocab(props.item)
  }

  // update timestamp
  let _updateUpdatedAt = () => {
    props.updateUpdatedAt(props.item)
  }

  // toggle 同音異義語
  let _toggleDoOnIgigoExists = () => {
    props.toggleDoOnIgigoExists(props.item)
  }

  // // toggle 重要後
  // let _toggleImportantWord = () => {
  //   props.toggleImportantWord(props.item)
  // }

  // toggle 重要度
  let _toggleImportantance = () => {

    if (importanceRanck === 2) {
      setImportanceRank(3)
      props.toggleImportantWord(props.item, 3)
    } else if (importanceRanck === 3) {
      setImportanceRank(1)
      props.toggleImportantWord(props.item, 1)
    } else {
      setImportanceRank(2)
      props.toggleImportantWord(props.item, 2)
    }
  }

  return (
    <Row style={{
      marginLeft: 0,
      marginRight: 0,
      marginTop: 10,
      marginBottom: 10,
      backgroundColor: props.idx % 2 === 0 ? '#efefef' : '#ffffff',
    }}>

      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>

        {props.item.kanji}

      </Col>
      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>
        {props.item.kana}
      </Col>
      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>
        {props.item.type3}
      </Col>
      <Col md="3" xs="12" style={{
        textAlign: 'left',
      }}>

        <FontAwesomeIcon
          onClick={_deleteVocab}
          icon="trash"
          style={{
          cursor: 'pointer',
          marginRight: 10,
          marginLeft: 10,
        }}/>

      </Col>

    </Row>
  )
}

export default MontoringWordItem
